import { Component,
  OnInit,
  Input
} from '@angular/core';
import { ActivatedRoute,
  Router,
  ParamMap
} from '@angular/router';
import { Store } from '@ngrx/store';

import { State } from '../../store/reducer';

import * as ArticlesActions from '../../store/actions';
import { Filter } from '../../models/filter.model';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-model-filter',
  templateUrl: './model-filter.component.html',
  styleUrls: ['./model-filter.component.scss']
})
export class ModelFilterComponent implements OnInit {
  allModels = [];
  query = '';
  make = {
    Name: '',
    Id: 0
  };
  @Input() isMobile: boolean;

  private group = Filter.getAggregationAndId('group');
  maxNumber = environment.defaultItemsNumber;
  private defaultMaxNumber = environment.defaultItemsNumber;
  showMoreButton = true;
  showLessButton = false;

  constructor(private store: Store<State>,
    private route: ActivatedRoute,
    private router: Router) {
  }

  ngOnInit() {
    this.store.select('articles').subscribe((state: any) => {
      if (state.loadedArticles) {
        if (!state.togglingSidenav
          && state.result.Aggregations.ApplicationsAggregationItem.BaseItems.length !== 0
          && state.result.Aggregations.ApplicationsAggregationItem.AggregationLevel === 2) {
          this.group = Filter.getAggregationAndId('group');

          if (!state.filters.Make.Name) {
            Filter.setFilterFromItemParent(state, 'Make', 'applications');
          }

          this.make = Filter.getValue('Make');

          Filter.resetValue('Model');

          if (Filter.Offset === 0) {
            this.allModels = [];

            Object.assign(this.allModels, state.result.Aggregations.ApplicationsAggregationItem.BaseItems);

            this.maxNumber = this.defaultMaxNumber;
            this.hideExtensionButtons();
          }

          this.store.dispatch({type: ArticlesActions.ActionTypes.CHANGE_FILTERS, payload: {
            filters: Filter
          }});
        }
      }
    });
  }

  navigateUp() {
    if (Filter.Query.length) {
      this.router.navigate([Filter.Query.join(' '), '1', 0, this.group.lvl, this.group.id], {relativeTo: this.route.parent});
    } else {
      this.router.navigate(['1', 0, this.group.lvl, this.group.id], {relativeTo: this.route.parent});
    }
  }

  navigateDown(item: any) {
    if (Filter.Query.length) {
      this.router.navigate([Filter.Query.join(' '), '3', item.Id, this.group.lvl, this.group.id], {relativeTo: this.route.parent});
    } else {
      this.router.navigate(['3', item.Id, this.group.lvl, this.group.id], {relativeTo: this.route.parent});
    }
  }

  showMore(show: boolean) {
    if (show) {
      this.maxNumber = this.allModels.length;
    } else {
      this.maxNumber = this.defaultMaxNumber;
    }
    this.showLessButton = show;
    this.showMoreButton = !show;
    this.hideExtensionButtons();
  }

  hideExtensionButtons() {
    if (this.allModels.length <= this.maxNumber) {
      this.maxNumber = this.allModels.length;
      this.showMoreButton = false;
      this.showLessButton = false;
    }
  }

}
